import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=1efa2254&scoped=true"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"
import style0 from "./StudentView.vue?vue&type=style&index=0&id=1efa2254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa2254",
  null
  
)

export default component.exports